import Link from 'next/link';

import { Trans } from '@flecto/translations'
import { type CoreProduct } from '@flecto/types'
import { Alert, type AlertProps } from '@flecto/ui'

import { useProductSlugEncode } from '../../hooks/useProductSlugEncode'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import { PopoverAdditionalBundles } from './PopoverAdditionalBundles'
import classes from './styles.module.css'

export type AlertProductWithinBundleOnlyProps = Omit<AlertProps, 'variant'> & {
  product?: CoreProduct
}

export function AlertProductWithinBundleOnly({
  product,
  ...props
}: AlertProductWithinBundleOnlyProps) {
  const bundlesBelongsTo = product?.item_attributes?.related_bundles ?? []

  const path = useStorePathBuilder()

  const allBundlesLength = bundlesBelongsTo.length

  const firstBundle = (bundlesBelongsTo?.[0] ?? {}) as CoreProduct

  const slug = useProductSlugEncode(firstBundle)

  const link = path(`/products/${slug}`)

  const message =
    allBundlesLength <= 1 ? (
      <Trans
        components={[
          <Link
            key='link-product-bundle-1'
            href={link}
            className={classes.link}
          />,
        ]}
        values={{ bundle_name: firstBundle.title }}
        i18nKey='store-page-product.label_alert_rent_within_bundle_only_single'
        ns='store'
      />
    ) : (
      <Trans
        components={[
          <Link
            key='link-product-bundle-1'
            href={link}
            className={classes.link}
          />,
          <PopoverAdditionalBundles
            key='popover-additional-bundles'
            bundles={bundlesBelongsTo}
          />,
        ]}
        values={{ bundle_name: firstBundle.title, count: allBundlesLength - 1 }}
        i18nKey='store-page-product.label_alert_rent_within_bundle_only_multiple'
        ns='store'
      />
    )

  if (
    bundlesBelongsTo.length <= 0 ||
    product?.bundle ||
    (!product?.bundle && product?.on_store)
  ) {
    return null
  }

  return <Alert {...props} variant='info' description={message} />
}
